export { TemplateService } from './src/template-service';
export { useTemplateSuggestion } from './src/use-template-suggestion';
export { SmartPageTemplate, TemplateComponentListMapping } from './src/consts';
export { applyTemplateSuggestion, templateSuggestionProxy } from './src/helper/apply-template-suggestion';
